import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types'
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { SortTypes } from '../enums/SortTypes';

const OfficeListHeaderSortLink = ({ sortValue, sort, reversed, onSortChanged, children }) => {

    const [isSelectedSort, setIsSelectedSort] = useState(false);

    const handleStatusSort = () => {
        if (sortValue === SortTypes.DEFAULT && sort === SortTypes.OFFICE_ID) {
            onSortChanged(sort, false);
        } else if (sort === SortTypes.DEFAULT && sortValue === SortTypes.READY_TO_ASSIGN) {
            onSortChanged(sortValue, true)
        } else {
            onSortChanged(sortValue, false)
        }
    }

    const handleReverse = () => {
        onSortChanged(sort, !reversed)
    }

    useEffect(() => {
        if ((sortValue === SortTypes.DEFAULT || sortValue === null || sortValue === SortTypes.NEW_MESSAGES)
            && (sort === SortTypes.DEFAULT || sort === null || sort === SortTypes.NEW_MESSAGES)) {
            setIsSelectedSort(true)
        } else {
            setIsSelectedSort(sort === sortValue)
        }
    }, [sort, sortValue])

    return !isSelectedSort ? (
        <a className='queue-header-link' onClick={handleStatusSort}>
            {children}
        </a>
    ) : (
            <div className='header-sort-link'>
                {children}
                <div className='header-direction-toggle' onClick={handleReverse}>
                    {reversed &&
                        <ExpandLessIcon />
                    }
                    {!reversed &&
                        <ExpandMoreIcon />
                    }
                </div>
            </div>
        )
}

OfficeListHeaderSortLink.propTypes = {
    sortValue: PropTypes.string.isRequired,
    sort: PropTypes.string,
    reversed: PropTypes.bool,
    onSortChanged: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired
}

export default OfficeListHeaderSortLink